const arrayToObject = <T>(arr: T[] = [], keyField: keyof T): { [key: string]: T } =>
  Object.assign({}, ...arr.map(item => ({ [(item[keyField] as unknown) as string]: item })));

export default arrayToObject;
